var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useMemo, useState } from 'react';
import { Button, Card, Table, Tag, Tooltip, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAdminRankingLevel, fetchAdminRankingLevels, updateAdminRankingLevel } from '../cores/api/api-dashboard';
import { RANKING_LEVELS_QUERY_KEY, STATUS_COLOR_MAP } from '../contants/option';
import RankingLevelFormModal from './form';
const resolveLevelStatus = level => level.active ? 'active' : 'inactive';
const STATUS_LABEL_MAP = {
    active: '有効',
    inactive: '無効'
};
const RANK_POSITION_TOOLTIP = '1が最高位です。新規ランクの位置は「ランク追加」の挿入位置で決まります。';
export default function RankingLevelsPage({ embedded = false }) {
    const _message$useMessage = message.useMessage(), _message$useMessage2 = _slicedToArray(_message$useMessage, 2), messageApi = _message$useMessage2[0], contextHolder = _message$useMessage2[1];
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isModalOpen = _useState2[0], setIsModalOpen = _useState2[1];
    const _useState3 = useState('edit'), _useState4 = _slicedToArray(_useState3, 2), modalMode = _useState4[0], setModalMode = _useState4[1];
    const _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), editingLevel = _useState6[0], setEditingLevel = _useState6[1];
    const queryClient = useQueryClient();
    const _useQuery = useQuery({
        queryKey: [...RANKING_LEVELS_QUERY_KEY, 'desc'],
        queryFn: () => fetchAdminRankingLevels({
            order_direction: 'desc'
        })
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    const levels = useMemo(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : []; }, [data === null || data === void 0 ? void 0 : data.data]);
    const invalidateLevels = () => __awaiter(this, void 0, void 0, function* () {
        yield queryClient.invalidateQueries({
            queryKey: RANKING_LEVELS_QUERY_KEY
        });
    });
    const createMutation = useMutation({
        mutationFn: params => createAdminRankingLevel(params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Create failed');
            }
            yield invalidateLevels();
            messageApi.success('ランクを追加しました。');
            closeModal();
        })
    });
    const updateMutation = useMutation({
        mutationFn: ({ id, params }) => updateAdminRankingLevel(id, params),
        onSuccess: (response) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!response.success) {
                throw new Error(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || response.error || 'Update failed');
            }
            yield invalidateLevels();
            messageApi.success('ランクを更新しました。');
            closeModal();
        })
    });
    const openCreateModal = () => {
        setModalMode('create');
        setEditingLevel(null);
        setIsModalOpen(true);
    };
    const openEditModal = level => {
        setModalMode('edit');
        setEditingLevel(level);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setEditingLevel(null);
    };
    const handleSubmit = (payload, options) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (options.isCreate) {
                yield createMutation.mutateAsync(payload);
            }
            else if (editingLevel) {
                yield updateMutation.mutateAsync({
                    id: editingLevel.id,
                    params: payload
                });
            }
        }
        catch (error) {
            messageApi.error(error.message || '保存に失敗しました。');
        }
    });
    const columns = [{
            title: /*#__PURE__*/ React.createElement(Tooltip, {
                title: RANK_POSITION_TOOLTIP
            }, /*#__PURE__*/ React.createElement("span", {
                className: "cursor-help"
            }, "\u9806\u4F4D")),
            key: 'rank_position',
            width: 56,
            align: 'center',
            render: (_, __, index) => /*#__PURE__*/ React.createElement("span", {
                className: "text-[13px] font-medium tabular-nums text-[#111827]"
            }, index + 1)
        }, {
            title: 'アイコン',
            dataIndex: 'image_url',
            width: 100,
            render: (value, record) => /*#__PURE__*/ React.createElement("div", {
                className: "flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-lg border border-[#e5e7eb] bg-[#f8fafc]"
            }, value ? /*#__PURE__*/ React.createElement("img", {
                src: value,
                alt: `${record.code} rank icon`,
                className: "h-full w-full object-cover"
            }) : /*#__PURE__*/ React.createElement("span", {
                className: "text-[11px] text-[#6b7280]"
            }, "No image"))
        }, {
            title: 'コード',
            dataIndex: 'code',
            width: 72,
            render: value => /*#__PURE__*/ React.createElement("span", {
                className: "text-[14px] font-semibold text-[#111827]"
            }, value)
        }, {
            title: 'ランク名',
            dataIndex: 'name',
            width: 140,
            render: value => /*#__PURE__*/ React.createElement("div", {
                className: "truncate text-[12px] text-[#374151]"
            }, value || '-')
        }, {
            title: '説明',
            dataIndex: 'description',
            width: 180,
            render: value => /*#__PURE__*/ React.createElement("div", {
                className: "line-clamp-2 text-[12px] text-[#6b7280]"
            }, value || '—')
        }, {
            title: 'STI',
            dataIndex: 'requires_sti_before_rank_up',
            width: 64,
            render: value => value ? '必須' : '-'
        }, {
            title: 'ユーザー数',
            dataIndex: 'users_count',
            width: 88,
            render: value => value !== null && value !== void 0 ? value : 0
        }, {
            title: 'ステータス',
            width: 100,
            render: (_, record) => {
                const status = resolveLevelStatus(record);
                return /*#__PURE__*/ React.createElement(Tag, {
                    color: STATUS_COLOR_MAP[status]
                }, STATUS_LABEL_MAP[status]);
            }
        }, {
            title: '',
            key: 'action',
            width: 100,
            render: (_, record) => /*#__PURE__*/ React.createElement(Button, {
                onClick: () => openEditModal(record)
            }, "\u7DE8\u96C6")
        }];
    return /*#__PURE__*/ React.createElement("div", {
        className: embedded ? '' : 'min-h-screen bg-[#f5f5f5] px-6 py-6'
    }, contextHolder, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-center justify-between gap-3"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0 text-[13px] text-[#6b7280]"
    }, "\u30E9\u30F3\u30AF\u306E\u8FFD\u52A0\u30FB\u8868\u793A\u540D\u30FB\u30A2\u30A4\u30B3\u30F3\u30FBSTI\u30B2\u30FC\u30C8\u3092\u3053\u306E\u753B\u9762\u3067\u7BA1\u7406\u3057\u307E\u3059\u3002\u9806\u4F4D1\u304C\u6700\u9AD8\u4F4D\u3067\u3059\u3002\u65B0\u898F\u30E9\u30F3\u30AF\u306E\u4F4D\u7F6E\u306F\u300C\u30E9\u30F3\u30AF\u8FFD\u52A0\u300D\u306E\u633F\u5165\u4F4D\u7F6E\u3067\u6C7A\u307E\u308A\u307E\u3059\u3002"), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: openCreateModal
    }, "\u30E9\u30F3\u30AF\u8FFD\u52A0"))), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        loading: isLoading,
        columns: columns,
        dataSource: levels,
        pagination: false,
        scroll: {
            x: 1160
        }
    }))), /*#__PURE__*/ React.createElement(RankingLevelFormModal, {
        open: isModalOpen,
        mode: modalMode,
        editingLevel: editingLevel,
        existingLevels: levels,
        loading: createMutation.isPending || updateMutation.isPending,
        onCancel: closeModal,
        onSubmit: handleSubmit
    }));
}
